import type { DayRecord } from './types';
import { dayKey, fmtHM } from './util';

/** Quote a CSV cell and neutralise spreadsheet formula injection (=, +, -, @, tab, CR). */
export function csvCell(v: string | number): string {
  let s = String(v);
  if (typeof v === 'string' && /^[=+\-@\t\r]/.test(s)) s = `'${s}`;
  return /[",\n\r]/.test(s) || s !== String(v) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function sessionsToCSV(history: Record<string, DayRecord>): string {
  const rows: string[] = ['date,end_time,minutes,task,interruptions'];
  const entries = Object.values(history)
    .flatMap((d) => d.log)
    .sort((a, b) => a.ts - b.ts);
  for (const e of entries)
    rows.push([dayKey(e.ts), fmtHM(e.ts), e.min, e.task ?? '', e.interruptions].map(csvCell).join(','));
  return rows.join('\r\n') + '\r\n';
}

export function dailyToCSV(history: Record<string, DayRecord>): string {
  const rows: string[] = ['date,sessions,minutes,interruptions'];
  for (const k of Object.keys(history).sort()) {
    const d = history[k]!;
    rows.push([k, d.sessions, d.minutes, d.interruptions].join(','));
  }
  return rows.join('\r\n') + '\r\n';
}
